import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../config/firebase";
import "./BlogDetail.css";

function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      const q = query(collection(db, "blogs"), where("slug", "==", slug));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        setBlog(snapshot.docs[0].data());
      }
    };
    fetchBlog();
  }, [slug]);

  if (!blog) return <p>Loading...</p>;

  return (
    <div className="blog-detail-page">
      <div className="blog-banner">
        <img src={blog.image} alt={blog.title} />
      </div>
      <div className="blog-body">
        <h1>{blog.title}</h1>
        <p className="meta">
          By {blog.author} •{" "}
          {new Date(blog.postDate.seconds * 1000).toLocaleDateString()}
        </p>
        <div
          className="blog-description"
          dangerouslySetInnerHTML={{ __html: blog.description }}
        ></div>
      </div>
    </div>
  );
}

export default BlogDetail;